import dayjs from 'dayjs';
import { Message } from 'element-ui';
import _ from 'lodash';

// 处理时间格式
export const formatSearchData = data => {
    const params = _.cloneDeep(data);
    params.createTimeStart = params.signTime ? dayjs(params.signTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.createTimeEnd = params.signTime ? dayjs(params.signTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.dispatchTimeStart = params.dispatchTime ? dayjs(params.dispatchTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.dispatchTimeEnd = params.dispatchTime ? dayjs(params.dispatchTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.siteNameList = params.siteName ? params.siteName.split(',') : [];
    params.siteCodeList = params.siteCode ? params.siteCode.split(',') : [];
    params.customerNames = params.customerName ? params.customerName.split(',') : [];
    params.customerCodes = params.customerCode ? params.customerCode.split(',') : [];
    delete params.signTime;
    delete params.dispatchTime;
    delete params.siteName;
    delete params.siteCode;
    delete params.customerName;
    delete params.customerCode;
    return params;
};

// 创建时间不能为空
export const validateSearchData = data => {
    if (data.companyCode) { // 分公司有值
        if (!data.dispatchTimeStart && !data.dispatchTimeEnd) {
            Message.warning('发车时间不可为空');
            return false;
        }
    } else {
        if (!data.dispatchNo && !data.carrierCode && !data.vehicleCard && !data.customerCode) {
            if (!data.dispatchTimeStart && !data.dispatchTimeEnd) {
                Message.warning('发车时间不可为空');
                return false;
            }
            if (!data.siteCodeList.length) {
                Message.warning('服务平台不可为空');
                return false;
            }
        }
    }
    return validateMaxDate(data, 'dispatchTimeStart', 'dispatchTimeEnd', { span: 1, unit: 'month', noMessage: false }, '发车时间');
};

/**
 * @description 校验查询时间跨度不能超过指定日期
 * @param {Object} searchData 查询参数
 * @param {String} sDateField 查询起始时间字段名
 * @param {String} eDateField 查询结束时间字段名
 * @param {{ span: number, unit: dayjs.ManipulateType, noMessage: boolean, addOneDay: boolean }} 配置时间范围限制
 */
const validateMaxDate = (searchData, sDateField, eDateField, options, searchType = '时间') => {
    if (searchData[sDateField] && searchData[eDateField]) {
        if (!options) {
            const sDateTimeStamp = new Date(searchData[sDateField]).getTime();
            const eDateTimeStamp = new Date(searchData[eDateField]).getTime();
            const maxDay = 1000 * 60 * 60 * 24 * 63; // 按31天来算，组件问题，得加多一天
            if (eDateTimeStamp - sDateTimeStamp > maxDay) {
                Message.warning(`按${searchType}查询或导出时，查询或导出时间跨度不可超过两个月`);
                return false;
            }
        } else {
            const { span = 2, unit = 'month', noMessage = false, addOneDay = true } = options || {};
            const sDate = dayjs(searchData[sDateField]);
            const eDate = dayjs(searchData[eDateField]);
            let addedTime = sDate.startOf('day')
                .add(span, unit);
            if (addOneDay) {
                addedTime = addedTime.add(1, 'day');
            }
            const eTime = eDate.endOf('day');
            const isValid = addedTime.isAfter(eTime);
            if (!isValid && !noMessage) {
                const unitNames = {
                    day: '天',
                    month: '个月',
                    week: '周',
                    year: '年'
                };
                Message.warning(`按${searchType}查询或导出时，查询或导出时间跨度不可超过${span}${unitNames[unit]}`);
            }
            return isValid;
        }
    }
    return true;
};
